import React from 'react'
import Banner from '../components/index/banner/Banner'
import TrendingProducts from '../components/index/trending_products/TrendingProducts'
import FlashDeals from '../components/index/flash_deals/FlashDeals'
import BackToUp from '@uiw/react-back-to-top';
import OurItem from '../components/index/our_item/OurItem'
import OurItemRight from '../components/index/our_item_right/OurItemRight'
import SaladPart from '../components/index/salad_part/SaladPart'
import Footers from '../components/index/footers/Footers'
import ProductsCategory from '../components/index/products_category/ProductsCategory'
const Home = () => {
  return (
     <>
        <Banner/>
        <TrendingProducts/>
        <ProductsCategory/>
        <FlashDeals/>
        <OurItem/>
        <OurItemRight/>
        <SaladPart/>
        <Footers/>
        
        <div className="container">
      <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
    </div>
     </>
  )
}

export default Home